import { EndorsementKey, type EndorsementConfig } from '../../types';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.RestaurantCoverage,
  label: 'Food Service Coverage',
  description: 'Add this coverage to protect from expenses associated with food spoilage and contamination.',
  recommended: true,
};
